module.exports = __webpack_public_path__ + "static/imagem_6-d64b93e55504fc3f965896db29b1ae0f.jpeg";